<agr-page [pageTitle]="pageTitle()">
  <div class="wrapper">
    <div class="row--container">
      <div class="row">
        <div class="col-6">
          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-card-title> Authenticated request </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div>
                <mat-form-field>
                  <mat-select placeholder="Request type" [(ngModel)]="devAuthrequest.requestType">
                    <mat-option value="get">GET</mat-option>
                    <mat-option value="post">POST</mat-option>
                    <mat-option value="put">PUT</mat-option>
                    <mat-option value="delete">DELETE</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="full-width-field">
                  <input
                    matInput
                    placeholder="Request url"
                    [(ngModel)]="devAuthrequest.requestURL"
                  />
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="full-width-field">
                  <textarea
                    cdkTextareaAutosize
                    matInput
                    placeholder="Request parameters"
                    [(ngModel)]="devAuthrequest.requestBody"
                  ></textarea>
                </mat-form-field>
              </div>
            </mat-card-content>
            <mat-card-actions>
              <agr-primary-action
                actionIcon="mail"
                [actionText]="'Send authenticated request'"
                (click)="makeRequest()"
                onKeyPress="makeRequest()"
              >
              </agr-primary-action>
            </mat-card-actions>
          </mat-card>
        </div>
      </div>
      <div class="row" *ngIf="response() as response">
        <div class="col-6">
          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-card-title> Response </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <pre>{{ response.devAuth | json }}</pre>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</agr-page>
